import { render, staticRenderFns } from "./ProductCart.vue?vue&type=template&id=60ed6fa8&"
import script from "./ProductCart.vue?vue&type=script&lang=js&"
export * from "./ProductCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports